/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M19.9999 11V7C19.9999 4.79086 18.209 3 15.9999 3V3M3.99988 11V7C3.99988 4.79086 5.79074 3 7.99988 3V3M9.99988 5H13.9999C15.1044 5 15.9999 4.10457 15.9999 3V3C15.9999 1.89543 15.1044 1 13.9999 1H9.99988C8.89531 1 7.99988 1.89543 7.99988 3V3C7.99988 4.10457 8.89531 5 9.99988 5Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M3.99988 8V14C3.99988 16.8003 3.99988 18.2004 4.54485 19.27C5.02421 20.2108 5.78911 20.9757 6.72993 21.455C7.79948 22 9.19962 22 11.9999 22V22C14.8001 22 16.2003 22 17.2698 21.455C18.2106 20.9757 18.9755 20.2108 19.4549 19.27C19.9999 18.2004 19.9999 16.8003 19.9999 14V8"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				d="M19.9999 14V7.49991C19.9999 5.01468 17.9852 3 15.5 3C15.5 4.10457 14.6045 5 13.5 5H10.5C9.3954 5 8.49997 4.10457 8.49997 3C6.01464 3 3.99988 5.01476 3.99988 7.50009V14C3.99988 16.8003 3.99988 18.2004 4.54485 19.27C5.02421 20.2108 5.78911 20.9757 6.72993 21.455C7.79948 22 9.19962 22 11.9999 22C14.8001 22 16.2003 22 17.2698 21.455C18.2106 20.9757 18.9755 20.2108 19.4549 19.27C19.9999 18.2004 19.9999 16.8003 19.9999 14Z"
				fill="currentColor"
			/>
			<path
				d="M16 3V3C18.2091 3 20 4.79086 20 7V14C20 16.8003 20 18.2004 19.455 19.27C18.9757 20.2108 18.2108 20.9757 17.27 21.455C16.2004 22 14.8003 22 12 22V22C9.19974 22 7.79961 22 6.73005 21.455C5.78924 20.9757 5.02433 20.2108 4.54497 19.27C4 18.2004 4 16.8003 4 14V7C4 4.79086 5.79086 3 8 3V3M16 3V3C16 1.89543 15.1046 1 14 1H10C8.89543 1 8 1.89543 8 3V3M16 3V3C16 4.10457 15.1046 5 14 5H10C8.89543 5 8 4.10457 8 3V3"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M10.136 0.25C8.85118 0.25 7.70111 1.04698 7.24994 2.25C5.0407 2.25 3.24976 4.04094 3.24976 6.25018V14.75C3.24976 17.5503 3.24976 18.9504 3.79472 20.02C4.27409 20.9608 5.03899 21.7257 5.9798 22.205C7.04936 22.75 8.44949 22.75 11.2498 22.75H12.7498C15.55 22.75 16.9501 22.75 18.0197 22.205C18.9605 21.7257 19.7254 20.9608 20.2048 20.02C20.7498 18.9504 20.7498 17.5503 20.7498 14.75V6.24982C20.7498 4.04078 18.959 2.25 16.7499 2.25C16.2988 1.04699 15.1488 0.25 13.864 0.25H10.136ZM9.99994 4.25C9.30958 4.25 8.74994 3.69036 8.74994 3C8.74994 2.30964 9.30958 1.75 9.99994 1.75H13.9999C14.6903 1.75 15.2499 2.30964 15.2499 3C15.2499 3.69036 14.6903 4.25 13.9999 4.25H9.99994Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M16 3V3C18.2091 3 20 4.79086 20 7V14.0001C20 16.8003 20 18.2004 19.4551 19.2699C18.9757 20.2108 18.2108 20.9757 17.2699 21.4551C16.2004 22 14.8003 22 12.0001 22H11.6562C9.17981 22 7.9416 22 6.97392 21.5711C5.8391 21.0681 4.93196 20.1609 4.42897 19.0261C4.00005 18.0584 4.00007 16.8202 4.00011 14.3438V14.3438L4 14M16 3C16 4.10457 15.1046 5 14 5H10C8.89543 5 8 4.10457 8 3M16 3C16 2.63571 15.9026 2.29417 15.7324 2C15.5568 1.69637 15.3036 1.4432 15 1.26756M8 3V3C5.79086 3 4 4.79086 4 7V9.5V10M8 3C8 1.89543 8.89543 1 10 1H12"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M15.9999 3V3C18.209 3 19.9999 4.79086 19.9999 7V14C19.9999 16.8003 19.9999 18.2004 19.4549 19.27C18.9755 20.2108 18.2106 20.9757 17.2698 21.455C16.2003 22 14.8001 22 11.9999 22V22C9.19962 22 7.79948 22 6.72993 21.455C5.78911 20.9757 5.02421 20.2108 4.54485 19.27C3.99988 18.2004 3.99988 16.8003 3.99988 14V7C3.99988 4.79086 5.79074 3 7.99988 3V3M15.9999 3V3C15.9999 1.89543 15.1044 1 13.9999 1H9.99988C8.89531 1 7.99988 1.89543 7.99988 3V3M15.9999 3V3C15.9999 4.10457 15.1044 5 13.9999 5H9.99988C8.89531 5 7.99988 4.10457 7.99988 3V3"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				fillRule="evenodd"
				clipRule="evenodd"
				d="M11.2498 2.25C8.44949 2.25 7.04936 2.25 5.9798 2.79497C5.03899 3.27433 4.27409 4.03924 3.79472 4.98005C3.24976 6.04961 3.24976 7.44974 3.24976 10.25V14.75C3.24976 17.5503 3.24976 18.9504 3.79472 20.02C4.27409 20.9608 5.03899 21.7257 5.9798 22.205C7.04936 22.75 8.44949 22.75 11.2498 22.75H12.7498C15.55 22.75 16.9501 22.75 18.0197 22.205C18.9605 21.7257 19.7254 20.9608 20.2048 20.02C20.7498 18.9504 20.7498 17.5503 20.7498 14.75V10.25C20.7498 7.44974 20.7498 6.04961 20.2048 4.98005C19.7254 4.03924 18.9605 3.27433 18.0197 2.79497C16.9501 2.25 15.55 2.25 12.7498 2.25H11.2498Z"
				fill="currentColor"
			/>
			<rect
				x="7"
				y="0.25"
				width="10"
				height="4"
				rx="2"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
